import { ComponentProps } from 'react';
import Space from 'antd/es/space';
import clsx from 'clsx';

import './OpSpace.scss';

interface OpSpaceProps extends ComponentProps<typeof Space> {
  block?: boolean;
}

/**
 * OpSpace is a wrapper around Ant Design's Space component.
 * It provides consistent spacing between child elements in horizontal or vertical layouts.
 *
 * Use this component to add uniform spacing between elements without manually managing margins.
 * Supports OpSpace.Compact for creating compact groups of related components.
 *
 * @example
 * <OpSpace orientation="horizontal" size="middle">
 *   <Button>Button 1</Button>
 *   <Button>Button 2</Button>
 * </OpSpace>
 *
 */
export const OpSpace = ({
  children,
  className,
  block,
  ...spaceProps
}: OpSpaceProps) => {
  return (
    <Space
      className={clsx('op-space', className, { 'op-space--fullWidth': block })}
      {...spaceProps}
    >
      {children}
    </Space>
  );
};

// Make the sub components available as a property on the wrapper component
OpSpace.Compact = Space.Compact;
